import React from 'react'
import { CustomCol } from 'src/components'
import { useWindowSize } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { Row, Button, Popconfirm } from 'antd'
import { CloudDownloadOutlined, CheckOutlined } from '@ant-design/icons'

interface DocumentButtonsProps {
  isVisible: boolean
  link: string
  linkLabel: string
  validateButtonLabel: string
  handleValidateButtonClick: () => void
  loading?: boolean
}

const ValidatePurchaseDocumentButtons: React.FC<DocumentButtonsProps> = (props) => {
  const { t } = useTranslation()
  const { width } = useWindowSize()
  const isMobile = width <= 800

  if (!props.isVisible) return

  return (
    <Row>
      <CustomCol>
        <a target={'_blank'} rel='noopener noreferrer' href={props.link}>
          <Button
            type='default'
            icon={<CloudDownloadOutlined />}
            className='radius-100'
            block={isMobile}
          >{props.linkLabel}
          </Button>
        </a>
      </CustomCol>
      <CustomCol>
        <Popconfirm
          okText={t('general.Yes')}
          cancelText={t('general.Cancel')}
          title={t('Document.Sure')}
          onConfirm={props.handleValidateButtonClick}
        >
          <Button
            type='primary'
            block={isMobile}
            icon={<CheckOutlined />}
            loading={props.loading}
            className={`radius-100 ${!isMobile ? 'ml-3' : 'mt-3'}`}
          >{props.loading ? t('Document.Validating') : props.validateButtonLabel}
          </Button>
        </Popconfirm>
      </CustomCol>
    </Row>
  )
}

export default ValidatePurchaseDocumentButtons
